import { FlatItem } from '@martech-solution/utils/types';
import { http } from '@martech-solution/utils/utils';

const controller = 'hr/projects';

export const getProjectsDropdown = async () => {
  return http.get<FlatItem[]>(`${controller}/dropdown`);
};
